"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLeaderboardContext = exports.LeaderboardProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
// ─── Context ──────────────────────────────────────────────────────────────────
const LeaderboardContext = (0, react_1.createContext)(null);
// ─── Provider ─────────────────────────────────────────────────────────────────
const LeaderboardProvider = ({ leaderboardData, courseData, eventData, currentRound, scoreCode = '', availableEvents = [], registrationData = [], factor = 1, appTheme, windowSize = {}, isPWA = false, headless = false, hideSelector = false, embedded = false, bottomPadding = 0, seriesPoints, children, }) => {
    // Internal display-toggle state
    const [standingTabs, setStandingTabs] = (0, react_1.useState)('individual');
    const [leaderboardScoreFormat, setLeaderboardScoreFormat] = (0, react_1.useState)('gross');
    const [showPar, setShowPar] = (0, react_1.useState)(true);
    const [showDist, setShowDist] = (0, react_1.useState)(true);
    const [showHdcp, setShowHdcp] = (0, react_1.useState)(true);
    const [showPoints, setShowPoints] = (0, react_1.useState)(true);
    const value = (0, react_1.useMemo)(() => ({
        // Data
        leaderboardData,
        courseData,
        eventData,
        currentRound,
        scoreCode,
        availableEvents,
        registrationData,
        // Display config
        factor,
        appTheme,
        windowSize,
        isPWA,
        isHeadless: headless,
        hideSelector,
        isEmbedded: embedded,
        bottomPadding,
        // Internal state
        standingTabs,
        setStandingTabs,
        leaderboardScoreFormat,
        setLeaderboardScoreFormat,
        showPar,
        setShowPar,
        showDist,
        setShowDist,
        showHdcp,
        setShowHdcp,
        showPoints,
        setShowPoints,
        seriesPoints,
    }), [
        leaderboardData, courseData, eventData, currentRound,
        scoreCode, availableEvents, registrationData,
        factor, appTheme, windowSize, isPWA, headless, hideSelector, embedded, bottomPadding,
        standingTabs, leaderboardScoreFormat, showPar, showDist, showHdcp, showPoints,
        seriesPoints,
    ]);
    return ((0, jsx_runtime_1.jsx)(LeaderboardContext.Provider, { value: value, children: children }));
};
exports.LeaderboardProvider = LeaderboardProvider;
// ─── Hook ─────────────────────────────────────────────────────────────────────
const useLeaderboardContext = () => {
    const context = (0, react_1.useContext)(LeaderboardContext);
    if (!context) {
        throw new Error('useLeaderboardContext must be used within a LeaderboardProvider');
    }
    return context;
};
exports.useLeaderboardContext = useLeaderboardContext;
